import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { ThemeProvider, Tooltip } from "@mui/material";

import { format } from "date-fns";

import GuidanceTableTheme from "../../../styles/tableTheme";
import IGuidance from "../../../types/IGuidance";
import PriceCell from "../../../components/PriceCell";

const GuidanceTable = ({
  data,
  updateCurrent,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  editing,
  setEditing,
}: {
  data: IGuidance[];
  updateCurrent: (current: IGuidance) => void;
  editing: boolean;
  setEditing: (editing: boolean) => void;
}) => {
  const onFocus = () => {
    setEditing(true);
  };
  return (
    <div>
      <ThemeProvider theme={GuidanceTableTheme}>
        {/* <TableContainer> */}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                className="columnRow currentCell"
                style={{ width: 100, minWidth: 100, maxWidth: 100 }}
              />
              {data.map((r: any) => (
                <TableCell className="columnHeader currentCell">
                  <Tooltip
                    title={
                      r.canEdit
                        ? "Create new Guidance"
                        : `Created at: ${format(
                            new Date(r.date),
                            "MMM dd yyyy h:mm aa"
                          )}`
                    }
                  >
                    <div className="GuidanceTableHeader">
                      {!r.canEdit && format(new Date(r.date), "MMM dd")}
                      {r.canEdit && "Current"}
                    </div>
                  </Tooltip>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell className="rowHeader currentCell">
                FOB Posted Px
              </TableCell>
              {data.map((r: any) => (
                <PriceCell
                  value={r.fobPrice}
                  setValue={(value: number) => {
                    updateCurrent({
                      ...r,
                      fobPrice: value,
                    });
                  }}
                  disabled={!r.canEdit}
                  onFocus={onFocus}
                />
              ))}
            </TableRow>
            <TableRow>
              <TableCell className="rowHeader currentCell">
                Alternative
              </TableCell>
              {data.map((r: any) => (
                <PriceCell
                  value={r.altPrice}
                  setValue={(value: number) => {
                    updateCurrent({
                      ...r,
                      altPrice: value,
                    });
                  }}
                  disabled={!r.canEdit}
                  onFocus={onFocus}
                />
              ))}
            </TableRow>
          </TableBody>
        </Table>

        {/* </TableContainer> */}
      </ThemeProvider>
    </div>
  );
};

export default GuidanceTable;
